import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Clan from '../Clan/Clan'
import Suitability from '../Suitability/Suitability'
import Flag from '../../../Flag/Flag'
import Stat, { STAT_TYPES } from '../Stat/Stat'

import {
    LANDING_CLANS_STAT_PLATOONS,
    LANDING_CLANS_STAT_STRONGHOLDS,
    LANDING_CLANS_STAT_GLOBAL_MAP,
    LANDING_CLANS_STAT_RESERVES,
    LANDING_CLANS_STAT_VICTORIES,
    LANDING_CLANS_STAT_LEVEL,
    LANDING_CLANS_STAT_PLAYERS,
    LANDING_CLANS_STAT_BATTLES,
} from '../../../../constants'

import { RecommendedClanPropTypes } from 'containers/Landing/propTypes'


import styles from './Front.scss'

const META_ORDER = [STAT_TYPES.victories, STAT_TYPES.players, STAT_TYPES.battles]
const SIMPLIFIED_META_ORDER = [STAT_TYPES.players, STAT_TYPES.level, STAT_TYPES.victories, STAT_TYPES.battles]

const Front = ({ clan, isSimple }) => {
    const {
        languages,
        tag,
        name,
        color,
        emblems,
        dwhClanReservesScore,
        dwhSquadScore,
        dwhStrongholdScore,
        dwhGlobalMapScore,
        winRate,
        battlesCount,
        membersCount,
        strongholdLevel,
    } = clan

    const STAT_TYPES_MAP = {
        [STAT_TYPES.players]: { number: membersCount, title: LANDING_CLANS_STAT_PLAYERS },
        [STAT_TYPES.level]: { number: strongholdLevel, title: LANDING_CLANS_STAT_LEVEL },
        [STAT_TYPES.victories]: { number: winRate, title: LANDING_CLANS_STAT_VICTORIES },
        [STAT_TYPES.battles]: { number: battlesCount, title: LANDING_CLANS_STAT_BATTLES },
    }

    const META_BLOCKS = isSimple ? SIMPLIFIED_META_ORDER : META_ORDER

    return (
        <div className={cx(styles.base, isSimple && styles.base__simple)}>
            <div className={styles.corners}>
                <div className={cx(styles.corner, styles.corner__topLeft)} />
                <div className={cx(styles.corner, styles.corner__topRight)} />
                <div className={cx(styles.corner, styles.corner__bottomRight)} />
                <div className={cx(styles.corner, styles.corner__bottomLeft)} />
            </div>
            <div className={styles.languages}>
                {languages.map((lang) => (
                    <Flag code={lang} key={lang} />
                ))}
            </div>
            <Clan
                tag={tag}
                name={name}
                color={color}
                emblem={emblems['195x195']}
            />
            <div className={styles.meta}>
                {META_BLOCKS.map((statType) => {
                    const { number, title } = STAT_TYPES_MAP[statType]

                    return (
                        <Stat
                            key={statType}
                            className={styles.metaItem}
                            type={statType}
                            number={number}
                            title={title}
                        />
                    )
                })}
            </div>
            {!isSimple && (
                <div>
                    <Suitability title={LANDING_CLANS_STAT_PLATOONS} level={dwhSquadScore} />
                    <Suitability
                        title={LANDING_CLANS_STAT_STRONGHOLDS}
                        level={dwhStrongholdScore}
                        strongholdLevel={strongholdLevel}
                    />
                    <Suitability title={LANDING_CLANS_STAT_GLOBAL_MAP} level={dwhGlobalMapScore} />
                    <Suitability title={LANDING_CLANS_STAT_RESERVES} level={dwhClanReservesScore} />
                </div>
            )}
        </div>
    )
}

Front.propTypes = {
    clan: RecommendedClanPropTypes,
    isSimple: PropTypes.bool,
}

export default Front



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/Front/Front.jsx